/*
  Adds custom color swatches under each product card in the "Bestsellers"
  Featured Collection section on a Dawn theme.

  This version keeps diagnostic console.log lines in place on purpose,
  so we can see exactly what's happening in the browser Console while
  we get this working. They're harmless to leave in long-term, but can
  be removed later once everything works reliably.
*/
(function () {
  console.log('[Bestsellers swatches] script is running');

  var SECTION_SELECTOR = '[id^="shopify-section-"][id*="featured_collection" i], .featured-collection';
  var CARD_SELECTOR = '.card-wrapper, .product-card-wrapper, .card';
  var IMAGE_SELECTOR = 'img';
  var PRICE_SELECTOR = '.price-item--regular, .price__regular .price-item, .price-item, .price';
  var LINK_SELECTOR = 'a[href*="/products/"]';

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
      try {
        return Shopify.formatMoney(cents, Shopify.money_format);
      } catch (e) {
        // fall through to basic formatting
      }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Tries several possible shapes for each entry in product.options:
  // a plain string, or an object using .name / .option_name / .title / .key
  function getOptionName(opt) {
    if (typeof opt === 'string') return opt;
    if (!opt || typeof opt !== 'object') return '';
    return opt.name || opt.option_name || opt.title || opt.key || '';
  }

  function findColorOptionIndex(product) {
    var index = -1;
    (product.options || []).forEach(function (opt, i) {
      var name = getOptionName(opt);
      if (/^colou?r(way)?s?$/i.test(name)) index = i;
    });
    return index;
  }

  function buildSwatches(cardEl, product, link) {
    var colorIndex = findColorOptionIndex(product);
    console.log(
      '[Bestsellers swatches]',
      product.title,
      '— raw options:', JSON.stringify(product.options),
      '— colorIndex:', colorIndex
    );
    if (colorIndex === -1) return;

    var wrap = document.createElement('div');
    wrap.className = 'bestsellers-swatches';

    var seen = {};
    product.variants.forEach(function (variant) {
      var value = variant.options[colorIndex];
      if (seen[value]) return;
      seen[value] = true;

      var image = (variant.featured_image && variant.featured_image.src) || product.featured_image;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bestsellers-swatch';
      btn.setAttribute('aria-label', 'Select color: ' + value);
      btn.setAttribute('aria-pressed', 'false');
      btn.title = value;
      if (image) {
        btn.style.backgroundImage = "url('" + image + "&width=100')";
      }
      btn.dataset.variantId = variant.id;
      btn.dataset.variantImage = image || '';
      btn.dataset.variantPrice = variant.price;
      btn.dataset.variantUrl = product.url + '?variant=' + variant.id;

      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.bestsellers-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        var mainImage = cardEl.querySelector(IMAGE_SELECTOR);
        if (mainImage && btn.dataset.variantImage) {
          mainImage.style.transition = 'opacity 0.15s ease';
          mainImage.style.opacity = '0';
          setTimeout(function () {
            mainImage.src = btn.dataset.variantImage + '&width=' + (mainImage.naturalWidth || 600);
            mainImage.srcset = '';
            mainImage.style.opacity = '1';
          }, 100);
        }

        var priceEl = cardEl.querySelector(PRICE_SELECTOR);
        if (priceEl) {
          priceEl.textContent = formatMoney(Number(btn.dataset.variantPrice));
        }

        if (link) {
          link.setAttribute('href', btn.dataset.variantUrl);
        }
      });

      wrap.appendChild(btn);
    });

    var infoTarget =
      cardEl.querySelector('.card__information') ||
      cardEl.querySelector('.card__content') ||
      cardEl;
    infoTarget.appendChild(wrap);
  }

  function initCard(cardEl) {
    var link = cardEl.querySelector(LINK_SELECTOR);
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    var handleUrl = href.split('?')[0];
    console.log('[Bestsellers swatches] fetching', handleUrl + '.js');

    fetch(handleUrl + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Could not load product data');
        return res.json();
      })
      .then(function (product) {
        buildSwatches(cardEl, product, link);
      })
      .catch(function (err) {
        console.warn('[Bestsellers swatches] skipped a card —', err.message);
      });
  }

  var sections = document.querySelectorAll(SECTION_SELECTOR);
  console.log('[Bestsellers swatches] sections matched:', sections.length);
  sections.forEach(function (section) {
    var cards = section.querySelectorAll(CARD_SELECTOR);
    console.log('[Bestsellers swatches] cards matched in this section:', cards.length);
    cards.forEach(initCard);
  });
})();